import React from "react";
import { motion } from "framer-motion";
import { HiOutlineDownload } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const CvDownloadCell = () => {
  const { t } = useTranslation();

  return (
    <motion.a
      variants={item}
      href="/CV AXEL CHEVENEMENT.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="bento-cell p-4 flex flex-col items-center justify-center gap-2 group cursor-pointer
                 lgl:col-start-11 lgl:col-end-13 lgl:row-start-2 lgl:row-end-4"
    >
      <div className="w-12 h-12 rounded-xl bg-designColor/10 flex items-center justify-center
                      group-hover:bg-designColor/20 group-hover:scale-110 transition-all duration-300">
        <HiOutlineDownload className="text-designColor text-xl" />
      </div>
      <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">
        {t("bento.cvDownload")}
      </span>
    </motion.a>
  );
};

export default CvDownloadCell;
